import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense'
import { loading, toast } from '@/shared/utils/UIHelper'

// Modal usado pelo TÉCNICO de viagem: ao aprovar a despesa (status 9 -> 1) ele escolhe o
// coordenador de destino. Espelha o addCoordinator de Despesas Diversos, mas chama
// ApprovedDespesaByidTecnico (ApprovedDespesaByid/{id}/{coordenadorId}) do fluxo de viagem.
export default {
  name: 'addTecnicoViagem',
  props: ['despesasidEnviarCoordenador', 'UnicaDespesa'],
  mixins: [ActionsForm, ExpenseMixin],
  components: { AutocompleteZ },
  data () {
    return {
      form: {
        coordenadorId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      }
    }
  },
  methods: {
    voltar () {
      this.$refs.responsavelTypeahead.clear()
      this.$emit('fecharEnviarCoordenador', true)
    },
    enviar () {
      if (this.UnicaDespesa) this.enviarUnicaDespesa()
      else this.enviarLote()
    },
    enviarLote () {
      if (!this.hasRole(this.roles.ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL) && !this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)) return
      let coordId = this.form.coordenadorId.value
      if (coordId === null || coordId === undefined) {
        toast.error('Escolha um Coordenador')
        return
      }
      let ids = Array.isArray(this.despesasidEnviarCoordenador) ? this.despesasidEnviarCoordenador : [this.despesasidEnviarCoordenador]
      loading.push()
      Promise.all(ids.map((id) => TravelExpenseRepository.ApprovedDespesaByidTecnico(id, coordId)))
        .then(() => {
          this.$emit('onloadReacarregar', true)
          this.$emit('fechaModalAprovacaoEnvioCoordenador', true)
          toast.success('Despesas Aprovadas com Sucesso!!')
          loading.pop()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao Aprovar as Despesas')
        })
    },
    enviarUnicaDespesa () {
      if (this.hasRole(this.roles.ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)) {
        if (this.form.coordenadorId.value !== null && this.form.coordenadorId.value !== undefined) {
          loading.push()
          TravelExpenseRepository.ApprovedDespesaByidTecnico(this.despesasidEnviarCoordenador, this.form.coordenadorId.value)
            .then(() => {
              this.$emit('onloadReacarregar', true)
              this.$emit('fechaModalAprovacaoEnvioCoordenador', true)
              toast.success('Despesa Aprovada com Sucesso!!')
              loading.pop()
            })
            .catch(() => {
              loading.pop()
              toast.error('Erro ao Aprovar a Despesa')
            })
        } else {
          toast.error('Escolha um Coordenador')
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/trevelexpenseemployee/components/addTecnicoViagem/addTecnicoViagem.js